import { render, staticRenderFns } from "./InquiryTransactionType.vue?vue&type=template&id=67a1c6cc&"
import script from "./InquiryTransactionType.vue?vue&type=script&lang=js&"
export * from "./InquiryTransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports